import { QuestionList } from './question-list';
import { Summary } from './summary';

export class ModuleList {
  details: {
      id: number,
      name: string,
      series_id: number,
      sequence_number: number,
      description: string,
      cover_url: string,
      video_url: string,
      video_duration: number,
      cover_color: string,
      module_points: number
  };
  quiz: {
      questions: QuestionList[];
  };
  summary: Summary[];

}
